import { useRef } from "react"
import { TourItemWrapper } from "./styled"
import ImgError from "assets/images/img-error.png"
import { useNavigate } from "react-router-dom"

const TourItem = ({ thumbnail, tourName, tourOldPrice, tourPrice, discount, slug }) => {
    const imgRef = useRef()
    const navigate = useNavigate()
    return (
        <TourItemWrapper className="bg-grey2 mt-15 mb-15" onClick={() => navigate(`/tour/${slug}`)}>
            <div className="image pt-10">
                <img ref={imgRef}
                    onError={() => imgRef.current.src = ImgError}
                    src={thumbnail ?? ""} alt="tour_image" />
            </div>
            <div className="px-10 pb-10">
                <div className="title">
                    <h1>{tourName} </h1>
                </div>
                <div className="discount mt-20">
                    {
                        discount > 0 && tourOldPrice > 0 &&
                        <strike className="mr-10 bold s-16 text-grey">{(parseInt(tourOldPrice)).toLocaleString('vi-VN')} đ</strike>
                    }
                    {
                        discount > 0 &&
                        <span className="bg-red text-white bold">Giảm {discount} %</span>
                    }
                </div>
                {
                    tourPrice && tourPrice > 0 &&
                    <div className="price">
                        <span>{(parseInt(tourPrice)).toLocaleString('vi-VN')} đ</span>
                    </div>
                }
                {
                    !tourPrice
                    &&
                    <div className="price">
                        <span>{parseInt(tourOldPrice - tourOldPrice / 100 * discount).toLocaleString('vi-VN')} đ</span>
                    </div>
                }
            </div>
        </TourItemWrapper>
    )
}

export default TourItem